import { FeedbackType } from "react-bootstrap/esm/Feedback";

export const MessageRequired: string = "Campo obrigatório.",
    MessageValid: string = "Ok.",
    MessageAutoManager: string = "Campo auto gerenciável.",
    FloatStepValue: number = 0.01,
    IntegerStepValue: number = 1,
    FloatRegex: string = "([0-9\,])",
    IntegerRegex: string = "[0-9]";



export const InitialMessage = (isValid: boolean): string => (isValid && MessageValid) || MessageRequired;

export const GetFeedbackType = (isValid: boolean): FeedbackType => isValid ? "valid" : "invalid";